import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { Card, Typography, units } from '@hbf/dsl';

import StudapartIcon from 'ha/custom-icons/studapart.svg';

import { useIntl } from 'ha/i18n';

import { useStudapart } from '../hooks/useStudapart';
import { ListingLinkToPartner } from './ListingLinkToPartner';

const useStyles = makeStyles()(theme => ({
  title: {
    fontSize: units.rem(1.125),
  },
  list: {
    paddingInlineStart: theme.spacing(2),
    marginBlockStart: theme.spacing(1),
    marginBlockEnd: 0,
    color: theme.palette.grey[700],
  },
  userContainer: {
    top: '100%',
    right: 0,
    left: 'unset',
  },
  withPadding: {
    padding: theme.spacing(2),
  },
  studapartIcon: {
    width: 'auto',
    height: units.rem(1.25),
    marginTop: theme.spacing(1),
  },
}));

const PartnerListingInfo: React.FC = () => {
  const { classes, cx } = useStyles();
  const { T } = useIntl();

  const { isStudapartListing } = useStudapart();

  return (
    <Card
      className={cx(classes.withPadding, classes.userContainer)}
      variant="outlined"
      data-test-locator="ListingOverviewDesktop"
    >
      {isStudapartListing && (
        <React.Fragment>
          <Typography.Caption>{T('ldp.studapart.caption')}</Typography.Caption>
          <StudapartIcon className={classes.studapartIcon} />
        </React.Fragment>
      )}
      <ListingLinkToPartner
        label={isStudapartListing ? T('View on %s', 'Studapart') : undefined}
      />
      {isStudapartListing ? (
        <React.Fragment>
          <Typography.H4 className={classes.title}>
            {T('ldp.studapart.info_title')}
          </Typography.H4>
          <ul className={classes.list}>
            {[
              T('ldp.studapart.info_1'),
              T('ldp.studapart.info_2'),
              T('ldp.studapart.info_3'),
              T('ldp.studapart.info_4'),
            ].map(key => (
              <li key={key}>{key}</li>
            ))}
          </ul>
        </React.Fragment>
      ) : (
        <Typography.Paragraph align="center">
          <b>{T('Note:')}</b>{' '}
          {T(
            'please be aware that this partner website may not offer the same safety guarantees as Housing Anywhere.',
          )}
        </Typography.Paragraph>
      )}
    </Card>
  );
};

export { PartnerListingInfo };
